import client from "./config";

//////////////// login ////////////////
const url = "admin/auth/login/";
export const loginRequest = (values) => client.post(url, values);
